module.exports = require('./helpers/bundle-url').getBundleURL('koVhS') + "Highlight1.6704459e.svg";